module.exports = __webpack_public_path__ + "static/img/showroom4.938d103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroom4.png
// module id = Z9oM
// module chunks = 2